import { DateTime } from 'luxon';

export type Period = 'today' | 'this_week' | 'this_month' | 'last_30_days' | 'last_90_days' | 'all_time';

export const PERIOD_LABELS: Record<Period, string> = {
  today: 'Today',
  this_week: 'This Week',
  this_month: 'This Month',
  last_30_days: 'Last 30 Days',
  last_90_days: 'Last 90 Days',
  all_time: 'All Time',
};

export const getPeriodDates = (period: Period): { start: string; end: string } => {
  const now = DateTime.now();
  const end = now.toISO()!;

  const startMap: Record<Period, DateTime> = {
    today: now.startOf('day'),
    this_week: now.startOf('week'),
    this_month: now.startOf('month'),
    last_30_days: now.minus({ days: 30 }),
    last_90_days: now.minus({ days: 90 }),
    all_time: DateTime.fromMillis(0),
  };

  return { start: startMap[period].toISO()!, end };
};
